import { List, MenuTitle, NavigationFilterWrapper } from './styled';
import { DistinctFacetItem } from '~/lib/data-contract/auto-generated/loop54-api-model';
import { NavigationFilterItem } from './NavigationFilterItem';
import { FilteredNodeProps } from './types';

export type { FilteredNodeProps } from './types';

export type NavigationFilterProps = {
    navigationTree: FilteredNodeProps[];
    navigationName?: string;
    facetDisplayName?: string;
    viewAll?: string;
    hasSelectedCategory: boolean;
    onSelectedFilterHandler: (
        selected: DistinctFacetItem,
        facetName?: string,
        facetDisplayName?: string,
    ) => void;
};

const NavigationFilter = ({
    hasSelectedCategory,
    navigationTree,
    navigationName,
    facetDisplayName,
    viewAll,
    onSelectedFilterHandler,
}: NavigationFilterProps) => {
    return (
        <NavigationFilterWrapper key={navigationName}>
            <MenuTitle variant="display5" as="h3">
                {facetDisplayName}
            </MenuTitle>

            {navigationTree ? (
                <List>
                    <NavigationFilterItem
                        key={`SideNavigationItem-all-0`}
                        facetName={navigationName}
                        facetDisplayName={viewAll}
                        onFilterClick={onSelectedFilterHandler}
                        link={{ text: viewAll, url: '' }}
                        filterValue={{ selected: !hasSelectedCategory }}
                    />
                    {navigationTree.map((item, index) => (
                        <NavigationFilterItem
                            key={`SideNavigationItem-${item.id}-${index}`}
                            facetName={navigationName}
                            facetDisplayName={facetDisplayName}
                            onFilterClick={onSelectedFilterHandler}
                            {...item}
                        />
                    ))}
                </List>
            ) : null}
        </NavigationFilterWrapper>
    );
};

export default NavigationFilter;
